// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import Enum from 'enum'

export default new Enum(['ENABLED', 'ARCHIVED'])


// WEBPACK FOOTER //
// ./src/scripts/constants/InboxStatusEnum.js